import { FC } from "react";
import { ExportBillingData } from "../../../../../../api-client";
import { Box } from "@mui/material";
import { PaperBillCard } from "./sub-components/PaperBillCard";

interface PaperBillCardListProps {
  bills: ExportBillingData[];
  todayString: string;
  selectedRxId: string | null;
  notes: Record<string, string>;
  updateNote: (billId: string, noteValue: string) => void;
  onRowClick: (row: any) => void;
  setSelectedRxId: (id: string) => void;
  handleMenuOpen: (event: React.MouseEvent<HTMLButtonElement>, row: any) => void;
  onRemoveAll: (billId: string) => void;
}
const PaperBillCardList: FC<PaperBillCardListProps> = ({
  bills,
  todayString,
  selectedRxId,
  notes,
  updateNote,
  onRowClick,
  setSelectedRxId,
  handleMenuOpen,
  onRemoveAll,
}) => {
  return (
    <>
      {bills.map((bill, billIndex) => (
        <Box
          className="bill-card"
          key={billIndex}
        >
          <PaperBillCard
            bill={bill}
            todayString={todayString}
            selectedRxId={selectedRxId}
            notes={notes}
            updateNote={updateNote}
            onRowClick={onRowClick}
            setSelectedRxId={setSelectedRxId}
            handleMenuOpen={handleMenuOpen}
            onRemoveAll={onRemoveAll}
          />
        </Box>
      ))}
    </>
  );
};

export default PaperBillCardList;
